module.exports = __webpack_public_path__ + "media/fonts/Quicksand-Light-d08d0358c31ea6202f2af102ddfc1c6d.ttf";